/* @flow */

import React from 'react';
import classNames from 'classnames';
import { ZNCODE } from './types';
import { mapData } from './map-data';
import type { Fakt } from './types';

export type Props = {
  activeState?: $Keys<typeof ZNCODE>,
  hoverState?: $Keys<typeof ZNCODE>,
  onStateChange: (state?: $Keys<typeof ZNCODE>, stayFocussed?: boolean) => void;
  activeFakt?: Fakt[],
}

const Map = ({
  activeState, hoverState, activeFakt, onStateChange,
}: Props): React$Element<"div"> => {
  const handleStateChange = (state?: $Keys<typeof ZNCODE>, stayFocussed?: boolean) => {
    onStateChange(state, stayFocussed);
  };

  return <div className='map-is__map'>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 586 793"
      className="map-is__svg-map svg-map"
      role="radiogroup"
      aria-label="Deutschland Karte"
    >
    {mapData.map(({ id, name, path }) => {
      const faktData = activeFakt && activeFakt.find(f => f.faktregion.zncode === id);

      return (
        <path
          key={id}
          id={id}
          name={name}
          aria-label={name}
          d={path}
          className={classNames(
            'svg-map__location',
            'map-is__location',
            `map-is__location--${id}`,
            activeState === id && 'map-is__location--active',
            hoverState === id && 'map-is__location--hover',
            ((!faktData && activeFakt) || (faktData && faktData.amount === null)) && 'map-is__location--inactive',
          )}
          tabIndex={id !== 'BW' ? 0 : -1}
          role='radio'
          aria-checked={activeState === id}
          onMouseEnter={() => handleStateChange(id)}
          onMouseLeave={() => handleStateChange(undefined)}
          onClick={() => handleStateChange(id, true)}
          onFocus={() => handleStateChange(id)}
          onBlur={() => handleStateChange(undefined)}
          >
        </path>
      );
    })}
    </svg>
  </div>;
};

export default Map;
